module.exports = __webpack_public_path__ + "static/glorious_3-72e2754efd756b7e768372b571d66700.jpg";